import React, { Component } from 'react';
import '../styles/GlobalStyle.css';
import ColType from '../Types';
import { db } from '../firebase/Firebase';
import { Form, Input, Button, Icon, Modal, notification, DatePicker } from 'antd';
import moment from 'moment';
const { TextArea } = Input;
const FormItem = Form.Item;
const successMessage = (description) => {
    notification.open({
        type: 'success',
        message: description,
        placement: 'bottomRight'
    });
};
const errorMessage = (description) => {
    notification.open({
        type: 'error',
        message: description,
        placement: 'bottomRight'
    });
};
// Long labels need these to wrap inside the modal.
const labelStyle = {
    display: 'inline',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    fontWeight: 600,
    color: '#1e293b'
};
// Fields that are no longer collected. Existing values are preserved,
// otherwise they are written as empty for backward compatibility.
const deprecatedFieldDefaults = {
    subject: '',
    gradeLevel: '',
    assessmentNumber: '',
    attendees: '',
    questionAnalysis: '',
    reasonsForErrors: '',
    discussionNotes: '',
    resourceForReteaching: '',
    dateTimeReteach: '',
    postAssessment: '',
    insightsGleaned: '',
    teacherName: '',
    date: null,
    coTeachDate: null,
    coTeachTime: '',
};
class SchoolTeamworkReportUpdateForm extends Component {
    state = {
        modalVisible: false,
        submitting: false,
        formData: [
            {
                label: "Coach's first name",
                fieldDecorator: 'coachFirstName',
                placeholder: 'First name',
                type: 'input',
                required: true
            },
            {
                label: "Coach's last name",
                fieldDecorator: 'coachLastName',
                placeholder: 'Last name',
                type: 'input',
                required: true
            },
            {
                label: 'Which grade level/content area are you solving in this plan that is connected to your school improvement goals?',
                fieldDecorator: 'focusArea',
                placeholder: 'For example: 4th grade math, or 9th grade ELA',
                type: 'textarea',
                required: true
            },
            {
                label: 'What data is informing your coaching practice this week?',
                fieldDecorator: 'dotItData',
                placeholder: 'Describe the data you looked at and what it told you',
                type: 'textarea',
                required: true
            },
            {
                label: 'What steps will you take to solve the problem? Include days and times',
                fieldDecorator: 'solutionSteps',
                placeholder: 'List the steps you will take, along with the days and times',
                type: 'textarea',
                required: true
            },
            {
                label: 'Share what you learned from coaching',
                fieldDecorator: 'coTeachingResults',
                placeholder: 'What worked, what surprised you, and what comes next',
                type: 'textarea',
                required: true
            },
            {
                label: 'If applicable, upload your district resource on the standard page. Why did you upload this resource? (Optional)',
                fieldDecorator: 'resourceExplanation',
                placeholder: 'Explain why you chose that resource',
                type: 'textarea',
                required: false
            },
        ]
    };
    componentDidMount() {
        if (this.props.report) {
            let formObj = {};
            for (let formVal of this.state.formData) {
                if (this.props.report.hasOwnProperty(formVal.fieldDecorator) &&
                    this.props.report[formVal.fieldDecorator]) {
                    if (formVal.type === 'date') {
                        formObj[formVal.fieldDecorator] = moment(this.props.report[formVal.fieldDecorator].toDate());
                    } else {
                        formObj[formVal.fieldDecorator] = this.props.report[formVal.fieldDecorator];
                    }
                }
            }
            this.props.form.setFieldsValue(formObj);
        }
    }
    showModal = () => {
        this.setState({ modalVisible: true });
    };
    handleCancel = () => {
        this.setState({ modalVisible: false });
    };
    handleSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!(this.props.schoolId && this.props.districtId && this.props.report)) {
            console.error('Missing required props', this.props);
            return;
        }
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState({ submitting: true });
                if (!values.resourceExplanation) {
                    values.resourceExplanation = '';
                }
                // Backward compatibility: keep removed fields on the document,
                // preserving any existing value.
                Object.keys(deprecatedFieldDefaults).forEach(field => {
                    values[field] = this.props.report.hasOwnProperty(field) && this.props.report[field] ?
                        this.props.report[field] : deprecatedFieldDefaults[field];
                });
                db.collection(ColType.schoolTeamworkReport)
                    .doc(this.props.report.id)
                    .update(values)
                    .then(() => {
                        successMessage('Coaching report updated.');
                        this.setState({ submitting: false });
                        this.handleCancel();
                    })
                    .catch((error) => {
                        console.error("Error updating document: ", error);
                        errorMessage('Error updating report. Please try again.');
                        this.setState({ submitting: false });
                    });
            }
        });
    };
    renderField = (item, key) => {
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: { xs: { span: 24 }, sm: { span: 24 } },
            wrapperCol: { xs: { span: 24 }, sm: { span: 24 } },
        };
        return (
            <FormItem
                {...formItemLayout}
                label={<span style={labelStyle}>{item.label}</span>}
                key={key}
                className="form-item"
            >
                {getFieldDecorator(item.fieldDecorator, {
                    rules: [{ required: item.required, message: 'This field is required' }],
                })(
                    item.type === 'input' ? (
                        <Input size="large" placeholder={item.placeholder} />
                    ) : item.type === 'date' ? (
                        <DatePicker size="large" style={{ width: '100%' }} />
                    ) : item.type === 'textarea' ? (
                        <TextArea
                            rows={4}
                            size="large"
                            placeholder={item.placeholder}
                            className="textarea-field"
                        />
                    ) : null
                )}
            </FormItem>
        );
    };
    render() {
        return (
            <div className="update-form-container">
                <Button type="default" size='large' onClick={this.showModal} className="edit-button">
                    <Icon type="edit" /> Edit
                </Button>
                <Modal
                    title={
                        <div className="modal-header">
                            <img src="/dotit-logo-color-new.png" alt="logo" className="modal-logo" />
                            <span>Edit Coaching Report</span>
                        </div>
                    }
                    visible={this.state.modalVisible}
                    width={800}
                    footer={null}
                    onCancel={this.handleCancel}
                    className="report-modal"
                >
                    <Form onSubmit={this.handleSubmit} className="report-form block-label-form">
                        <div className="form-block">
                            <div className="name-grid">
                                {this.state.formData.slice(0, 2).map((item, index) => this.renderField(item, index))}
                            </div>
                            {this.state.formData.slice(2, 4).map((item, index) => this.renderField(item, index + 2))}
                        </div>
                        <div className="form-block">
                            {this.state.formData.slice(4, 5).map((item, index) => this.renderField(item, index + 4))}
                        </div>
                        <div className="form-section">
                            <h3>Coaching Documentation</h3>
                            {this.state.formData.slice(5, 6).map((item, index) => this.renderField(item, index + 5))}
                        </div>
                        <div className="form-block">
                            {this.state.formData.slice(6, 7).map((item, index) => this.renderField(item, index + 6))}
                        </div>
                        <div className="form-actions">
                            <Button
                                onClick={this.handleCancel}
                                size="large"
                                className="cancel-button"
                            >
                                Cancel
                            </Button>
                            <Button
                                type="primary"
                                htmlType="submit"
                                size="large"
                                disabled={this.state.submitting}
                                className="submit-button"
                            >
                                {this.state.submitting ? (
                                    <span><Icon type="loading" /> Updating...</span>
                                ) : (
                                    <span>Save Changes</span>
                                )}
                            </Button>
                        </div>
                    </Form>
                </Modal>
                <style jsx>{`
                    .update-form-container {
                        display: inline-block;
                    }
                    :global(.edit-button) {
                        border-radius: 10px;
                        color: #1e293b;
                    }
                    :global(.report-modal .ant-modal-content) {
                        border-radius: 16px;
                        overflow: hidden;
                    }
                    :global(.report-modal .ant-modal-header) {
                        background: #f0f7ff;
                        border-bottom: 1px solid #cfe3ff;
                        padding: 20px 24px;
                    }
                    :global(.report-modal .ant-modal-title) {
                        font-size: 20px;
                        font-weight: 800;
                        color: #1e293b;
                    }
                    .modal-header {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                    }
                    .modal-logo {
                        height: 28px;
                        width: auto;
                    }
                    .report-form {
                        padding: 20px 0;
                    }
                    .form-block {
                        margin-bottom: 24px;
                    }
                    .form-section {
                        margin-bottom: 32px;
                    }
                    .form-section h3 {
                        font-size: 18px;
                        font-weight: 700;
                        color: #1e293b;
                        margin-bottom: 16px;
                        padding-bottom: 8px;
                        border-bottom: 1px solid #e8eef5;
                    }
                    .name-grid {
                        display: grid;
                        grid-template-columns: 1fr 1fr;
                        gap: 20px;
                    }
                    .plan-grid {
                        display: grid;
                        grid-template-columns: 1fr 1fr;
                        gap: 20px;
                    }
                    :global(.form-item .ant-input, .form-item .ant-select-selection, .form-item .ant-calendar-picker-input) {
                        border: 1px solid #dbe6f2;
                        border-radius: 10px;
                        transition: all 0.2s ease;
                    }
                    :global(.form-item .ant-input:focus, .form-item .ant-select-selection:focus, .form-item .ant-calendar-picker-input:focus) {
                        border-color: #1098f7;
                        box-shadow: 0 0 0 2px rgba(16, 152, 247, 0.18);
                    }
                    :global(.textarea-field) {
                        border: 1px solid #dbe6f2;
                        border-radius: 10px;
                        transition: all 0.2s ease;
                    }
                    :global(.textarea-field:focus) {
                        border-color: #1098f7;
                        box-shadow: 0 0 0 2px rgba(16, 152, 247, 0.18);
                    }
                    .form-actions {
                        display: flex;
                        justify-content: flex-end;
                        gap: 15px;
                        margin-top: 30px;
                        padding-top: 20px;
                        border-top: 1px solid #e8eef5;
                    }
                    :global(.submit-button.ant-btn-primary) {
                        background: #1098f7;
                        border-color: #1098f7;
                        border-radius: 10px;
                        font-weight: 600;
                    }
                    :global(.submit-button.ant-btn-primary:hover),
                    :global(.submit-button.ant-btn-primary:focus) {
                        background: #0b86dd;
                        border-color: #0b86dd;
                    }
                    :global(.cancel-button) {
                        border-radius: 10px;
                        color: #475569;
                    }
                    @media (max-width: 768px) {
                        .name-grid,
                        .plan-grid {
                            grid-template-columns: 1fr;
                        }
                        .form-actions {
                            flex-direction: column;
                        }
                    }
                `}</style>
            </div>
        );
    }
}
export default Form.create()(SchoolTeamworkReportUpdateForm);